import { render, staticRenderFns } from "./InvoicePrizeDetail.vue?vue&type=template&id=bca91e4c&"
import script from "./InvoicePrizeDetail.vue?vue&type=script&lang=js&"
export * from "./InvoicePrizeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports